module.exports = "images/nav-workstations-20171010.jpg";